// ©2024 Austin App House. All rights reserved.
const values = {
  entityType: 'Individual/sole proprietor',
  isEINDisplayed: false,
};

export default values;
